<div class="sh-form-toggle-switch" [title]="label">
    <label class="sh-form-group__input sh-form-toggle-switch__switch sh-toggle-switch__switch" [for]="id">
        <input #checkboxEl type="checkbox" [id]="id" [formControl]="control" />
        <span class="sh-toggle-switch__slider"></span>
    </label>
    <label [for]="id" class="sh-form-toggle-switch__label sh-form-group__label">{{ label }} </label>

    @if (description) {
        <small class="sh-form-toggle-switch__subscript">
            {{ description }}
        </small>
    }
</div>
